import { render, staticRenderFns } from "./RegistrationCompleted.vue?vue&type=template&id=7ce63cb4&"
import script from "./RegistrationCompleted.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports